<template>
    <div class="user-account">
        <user-info />
        <account-info />
        <billing-info />
        <update-password />
        <api-token />
    </div>
</template>

<script>
import AccountInfo from '@/components/Dashboard/Settings/Account/AccountInfo.vue';
import UserInfo from '@/components/Dashboard/Settings/Account/UserInfo.vue';
import UpdatePassword from '@/components/Dashboard/Settings/Account/UpdatePassword.vue';
import BillingInfo from '@/components/Dashboard/Settings/Account/BillingInfo.vue';
import ApiToken from '@/components/Dashboard/Settings/Account/ApiToken.vue';

export default {
    components: {
        AccountInfo,
        UserInfo,
        UpdatePassword,
        BillingInfo,
        ApiToken,
    },
};
</script>
